<template>
    <v-container grid-list-xl>
        <v-layout wrap justify-space-between v-if="new_password">
            <v-flex xs12 md12>
                <h1>회원가입 완료</h1>
                <div v-if="engine == 'AWSSNS'">
                    <div>
                        <br />기본 패스워드를 생성해서 휴대폰으로 전송했습니다.
                        <br />로그인 후 변경 가능합니다.
                    </div>
                    <div
                        style="border: 2px solid black; padding: 10px; width: 250px; margin: 0 auto; background: yellow;"
                    >
                        <div style="font-size: 2em;">
                            임시 비밀번호
                        </div>
                        <div style="font-size: 3em;">
                            {{ new_password }}
                        </div>
                    </div>
                </div>

                <br /><v-btn to="/"> 로그인</v-btn>
            </v-flex>

            <v-flex xs12 md12>
                <h1>User Registration Success</h1>
                <div v-if="engine == 'AWSSNS'">
                    <div>
                        <br />Complex new passwords are easy to forget, so ....
                        <br />We sent a new password to your phone. <br />Don't
                        like it? You can change it afer logging in.
                    </div>
                </div>

                <div v-if="new_password == 'USER'">
                    You may now login with your chosen password
                </div>

                <div v-if="new_password != 'USER'">
                    This is your password. Save it and change it later if you
                    want.
                    <div
                        style="border: 2px solid black; padding: 10px; width: 250px; margin: 0 auto; background: yellow;"
                    >
                        <div style="font-size: 2em;">
                            Your Password
                        </div>
                        <div style="font-size: 3em;">
                            {{ new_password }}
                        </div>
                    </div>
                </div>

                <br /><v-btn to="/"> Login </v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap justify-space-between v-else-if="!phone_validated">
            <v-flex xs12 md12>
                <h1>회원가입</h1>
                <h1>User Registration</h1>
            </v-flex>

            <v-flex xs12 md12>
                <v-form ref="phone_form">
                    <v-layout row wrap>
                        <v-flex pa-0 xs12>
                            <v-subheader class="formlabel"
                                >휴대전화 Mobile Phone Number</v-subheader
                            >
                        </v-flex>
                        <v-flex py-0 xs3 formlabeless>
                            <v-select
                                :items="countries"
                                label=""
                                prefix=""
                                v-model="cc"
                                xs6
                            ></v-select>
                        </v-flex>
                        <v-flex py-0 xs9 formlabeless>
                            <v-text-field
                                v-model="phone"
                                :rules="[rules.phone]"
                                :error-messages="phone_error_messages"
                                :disabled="phone_validated"
                                @input="phone_error_messages = []"
                                label=""
                                type="number"
                                pattern="\d*"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="ask_password">
                            <v-text-field
                                v-model="password"
                                :rules="rules.passwordRules"
                                :error-messages="password_error_messages"
                                type="password"
                                label="New Password"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="ask_password">
                            <v-text-field
                                v-model="password_again"
                                :rules="[confirmPasswordRules]"
                                type="password"
                                label="New Password Again"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
            <v-btn @click="check" :disabled="phone_validated"
                >인증번호 받기 / Check Mobile Phone Number</v-btn
            >
            <br />
            To control costs, we have limited the countries supported. If your
            country is not supported, please contact support@taptags.com.
        </v-layout>

        <v-layout wrap justify-space-between v-else-if="phone_validated">
            <v-flex xs12 md12>
                <h1>Check SMS sent to: <br />{{ cc }} {{ phone }}</h1>
            </v-flex>
            <v-flex xs12 md12>
                Your confirmation code will come from [TapTags]
                <br />인증번호는 [TapTags]을 통해서 발송됩니다.
                <br />
            </v-flex>

            <v-flex xs12 md12>
                <v-form ref="confirm_form" @submit.prevent="confirm">
                    <v-text-field
                        v-model="confirmation"
                        :counter="6"
                        :rules="[rules.confirmation_numbers]"
                        :error-messages="confirmation_error_messages"
                        label="인증번호 6자리를 입력하세요.  Confirmation #"
                        type="number"
                        pattern="\d*"
                    ></v-text-field>
                </v-form>
            </v-flex>
            <v-btn color="primary" @click="confirm"> Confirm</v-btn>
            <v-btn @click="uncheck"
                >전화번호 수정하기 / Change Phone Number</v-btn
            >
        </v-layout>
        <br />
        <h2 class="headline font-weight-bold mb-3">Need Help?</h2>
        Having trouble or need help? Email 주소 daltotheworld@gmail.com
    </v-container>
</template>

<script>
import {
    phone_countries,
    country_abbreviation_to_country_code,
} from "@/settings";
export default {
    props: ["auth"],
    data: () => ({
        cc: "",
        phone: "10",
        phone_validated: false,
        phone_error_messages: [],
        confirmation: "",
        confirmation_disabled: true,
        confirmation_error_messages: [],
        valid: false,
        countries: phone_countries,
        ask_password: false,
        password: undefined,
        password_again: undefined,
        password_error_messages: [],
        new_password: "", // when auto generated for display
        engine: "",
        rules: {
            required: (value) => !!value || "Required.",
            counter: (value) => value.length <= 20 || "Max 20 characters",
            confirmation_numbers: (value) => {
                const pattern = /^\d{6}$/;
                return pattern.test(value) || "Should only 6 digits";
            },
            phone: (value) => {
                const pattern = /^\d+$/;
                return pattern.test(value) || "Invalid phone number";
            },
            email: (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
            passwordRules: [
                (value) => !!value || "Please type password.",
                (value) =>
                    (value && value.length >= 6) || "minimum 6 characters",
            ],
        },
    }),
    beforeMount: async function() {
        if (this.$route.params.save_phone) {
            this.$data.phone = this.$route.params.save_phone;
            this.phone_validated = true;
        }
        if (this.$route.params.save_cc) {
            this.$data.cc = this.$route.params.save_cc;
        } else {
            var res = await this.auth.guess_country();
            console.log(
                "country_abbreviation_to_country_code",
                country_abbreviation_to_country_code
            );
            this.$data.cc =
                country_abbreviation_to_country_code[res.data.country];
        }
    },
    watch: {
        phone(to) {
            if (to?.startsWith("0")) {
                this.$data.phone = to.replace(/^0/, "");
            }
        },
        cc(to, from) {
            if (to != "+82" && this.$data.phone == "10") {
                this.$data.phone = "";
            }
            if (to == "+82" && !this.$data.phone) {
                this.$data.phone = "10";
            }
            let twilio_countries = ["+1", "+65", "+44", "+91"];
            let bypass_countries = ["+86"];
            if (
                twilio_countries.includes(to) ||
                bypass_countries.includes(to)
            ) {
                this.$data.ask_password = true;
            } else {
                this.$data.ask_password = false;
            }
        },
    },
    computed: {},
    methods: {
        stopsafari: function() {
            console.log("no auto-submit");
            return false;
        },
        confirmPasswordRules: function() {
            /*
        if (this.password.length < 6) {
            //this.password_error_messages = ["Password too short"]
            return "Password too short";
        }
        */
            if (this.password != this.password_again) {
                //this.password_error_messages = ["Password does not match"]
                return "Password does not match";
            }
            this.password_error_messages = [];
            return true;
        },
        check: async function({ router }) {
            if (this.$refs.phone_form.validate()) {
                var res = await this.auth.register(
                    this.cc,
                    this.phone,
                    this.password
                );
                console.log("check result", res);
                if (!res.data.success) {
                    this.phone_error_messages = res.data.message;
                    console.log(
                        "fail phone",
                        this.phone_error_messages,
                        res.data.message
                    );
                } else {
                    this.phone_validated = true;

                    // Some countries w/o veriy can go direct
                    // Custom message when new password must be directly shown
                    this.engine = res.data.engine;
                    this.new_password = res.data.new_password;

                    // reload session (CN)
                    this.auth.check_session();

                    // If we must carry on to actual verification, push the route to avoid safari killing state when it reloads on sms pin autofill
                    if (this.engine != "BYPASS") {
                        this.$router.push(
                            {
                                name: "register_waitcode",
                                params: {
                                    save_cc: this.cc,
                                    save_phone: this.phone,
                                },
                            }
                            // `/profile/register/waitcode/${this.cc}/${resp.data.order.id}`,
                        );
                    }
                }
            }
        },
        uncheck() {
            this.phone_validated = false;
        },
        confirm: async function() {
            if (!this.$refs.confirm_form.validate()) {
                this.confirmation_error_messages = "Incorrect Number";
                return false;
            }

            var res = await this.auth.authsms_verify(
                this.cc,
                this.phone,
                this.confirmation
            );
            console.log("verify result", res);

            if (!res.data.success) {
                this.confirmation_error_messages =
                    "Invalid Confirmation Code.  Please check the NEWEST message and try again";
                console.log(
                    "fail confirmation",
                    this.confirmation_error_messages,
                    res.data.message
                );
            } else {
                this.valid = true;
                localStorage.setItem("last_cc", this.$data.cc);
                localStorage.setItem("last_phone", this.$data.phone);

                // Custom message when new password must be directly shown
                this.engine = res.data.engine;
                this.new_password = res.data.new_password;

                // reload session
                this.auth.check_session(); // AWSSNS TWILIO

                //this.$router.push('/profile/register_success');
                return;
            }
        },
    },
};
</script>
<style scoped>
.formlabel {
    height: auto;
    padding: 0 10px;
}
.formlabeless .v-input {
    padding-top: 0px;
}
</style>
